export default "__VITE_ASSET__3abefc5d__"